import{
    INSERT_CUPOM_DESCONTO,
    INSERT_CUPOM_DESCONTOLOADING,
    
    VALIDAR_CUPOM_PASSWORD,
    VALIDAR_CUPOM_PASSWORDLOADING,

    CUPOM_GERENCIADOR_LIST,
    CUPOM_GERENCIADOR_LISTLOADING,
    CUPOM_GERENCIADOR_LISTERROR,

    CUPOM_GERENCIADOR_VENDEDOR_LIST,
    CUPOM_GERENCIADOR_VENDEDOR_LISTLOADING

} from '../actions/ActionsTypes';

const INITIAL_STATE = {
    cupomDesconto: [],
    cupomDescontoLoader: false,

    validarSenha: false,
    validarSenhaLoader: false,

    cupomGerenciadorList: [],
    cupomGerenciadorListByStatus: {
        ATIVO: [],
        INATIVO: [],
        ELEGIVEL: [],
        INELEGIVEL: []
    },
    cupomGerenciadorLoader: false,
    cupomGerenciadorLoaderByStatus: {
        ATIVO: false,
        INATIVO: false,
        ELEGIVEL: false,
        INELEGIVEL: false
    },
    cupomGerenciadorErro: '',
    cupomGerenciadorErroByStatus: {
        ATIVO: '',
        INATIVO: '',
        ELEGIVEL: '',
        INELEGIVEL: ''
    },

    cupomGerenciadorVendedoresList: [],
    cupomGerenciadorVendedoresLoader: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INSERT_CUPOM_DESCONTO:
            return { ...state, cupomDesconto: action.payload }

        case INSERT_CUPOM_DESCONTOLOADING:
            return { ...state, cupomDescontoLoader: action.payload }

        case VALIDAR_CUPOM_PASSWORD:
            return { ...state, validarSenha: action.payload }

        case VALIDAR_CUPOM_PASSWORDLOADING:
            return { ...state, validarSenhaLoader: action.payload }

        case CUPOM_GERENCIADOR_LIST: {
            const status = action.payload?.status || 'ATIVO';
            const lista = action.payload?.lista || [];

            return {
                ...state,
                cupomGerenciadorList: lista,
                cupomGerenciadorListByStatus: {
                    ...state.cupomGerenciadorListByStatus,
                    [status]: lista
                }
            }
        }

        case CUPOM_GERENCIADOR_LISTLOADING: {
            const status = action.payload?.status || 'ATIVO';
            const loading = !!action.payload?.loading;
            const loaders = {
                ...state.cupomGerenciadorLoaderByStatus,
                [status]: loading
            };

            return {
                ...state,
                cupomGerenciadorLoader: Object.keys(loaders).some(key => loaders[key]),
                cupomGerenciadorLoaderByStatus: loaders
            }
        }

        case CUPOM_GERENCIADOR_LISTERROR: {
            const status = action.payload?.status || 'ATIVO';
            const erro = action.payload?.erro || '';

            return {
                ...state,
                cupomGerenciadorErro: erro,
                cupomGerenciadorErroByStatus: {
                    ...state.cupomGerenciadorErroByStatus,
                    [status]: erro
                }
            }
        }

        case CUPOM_GERENCIADOR_VENDEDOR_LIST:
            return { ...state, cupomGerenciadorVendedoresList: action.payload }

        case CUPOM_GERENCIADOR_VENDEDOR_LISTLOADING:
            return { ...state, cupomGerenciadorVendedoresLoader: action.payload }

        default:
            return state
    }   
}
